import Collapse from './Collapse'

export default Collapse



// WEBPACK FOOTER //
// ./src/components/collapse/index.js